import { render, staticRenderFns } from "./subjectShowDialog.vue?vue&type=template&id=c30583e2&scoped=true&"
import script from "./subjectShowDialog.vue?vue&type=script&lang=js&"
export * from "./subjectShowDialog.vue?vue&type=script&lang=js&"
import style0 from "./subjectShowDialog.vue?vue&type=style&index=0&id=c30583e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30583e2",
  null
  
)

export default component.exports